export default "__VITE_ASSET__BbvvyMl5__"